import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { nodeCookie } from "@catchoftheday/utilities";
import { CONSTRUCTOR_CLIENT_ID, CONSTRUCTOR_SESSION_ID } from "../../consts";

// Fetch the base URL from process.env to support the minimal header and footer
// Ideally this should set up in the pipeline and fetched via env-config.
// But without further changes, we can't do that for now.
var getConfigApiURL = function getConfigApiURL() {
  return true ? "".concat(window.location.origin, "/config.json") : // eslint-disable-next-line n/no-process-env
  "".concat(process.env.NEXT_PUBLIC_COTD_WEBSITE_URL, "/config.json");
};

export var headerInitialProps = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(appContext) {
    var configFlags, response, req, cookies, cnstrClientId, cnstrSessionId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            configFlags = {};
            _context.prev = 1;
            _context.next = 4;
            return fetch(getConfigApiURL());

          case 4:
            response = _context.sent;
            _context.next = 7;
            return response.json();

          case 7:
            configFlags = _context.sent;
            _context.next = 13;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            console.error("Error fetching flags:", _context.t0);

          case 13:
            req = appContext.ctx.req;
            cookies = req ? nodeCookie.parse(req.headers.cookie || "") : {};
            cnstrClientId = cookies[CONSTRUCTOR_CLIENT_ID] || "1";
            cnstrSessionId = Number(cookies[CONSTRUCTOR_SESSION_ID]) || 1;
            return _context.abrupt("return", {
              configFlags: configFlags,
              headerCookies: {
                cnstrClientId: cnstrClientId,
                cnstrSessionId: cnstrSessionId
              }
            });

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));

  return function headerInitialProps(_x) {
    return _ref.apply(this, arguments);
  };
}();